import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// mui + fonts
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
// TESTING FONTS
import "@fontsource/dm-mono";
// Supports weights 100-900
import "@fontsource-variable/montserrat";
// Supports weights 100-800
import "@fontsource-variable/martian-mono";

// routing
import { BrowserRouter, Route, Routes } from "react-router-dom";
import routingObject from "./routingObject";

// our providers
import CustomThemesProvider from "./Providers/CustomThemesProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <CustomThemesProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<App />}>
            {Object.entries(routingObject).map(([path, { Component }]) => (
              <Route key={path} path={path} element={<Component />} />
            ))}
            <Route path="*" element={<h1>404 not found</h1>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </CustomThemesProvider>
  </React.StrictMode>
);
